import IconAbrdn from "../../assets/images/home/abrdn.svg";
import IconAvatrade from "../../assets/images/home/avatrade.svg";
import IconDirexion from "../../assets/images/home/direxion.svg";
import IconEqm from "../../assets/images/home/EQM.svg";
import IconGain from "../../assets/images/home/gain.svg";
import IconGlobalx from "../../assets/images/home/globalx.svg";
import IconIClima from "../../assets/images/home/iclima.svg";
import IconImpak from "../../assets/images/home/impak.svg";
import IconLgc from "../../assets/images/home/lgc.svg";
import IconLmax from "../../assets/images/home/lmax.svg";
import IconMelanion from "../../assets/images/home/melanion.svg";
import IconPepperstone from "../../assets/images/home/pepperstone.svg";
import IconPlus500 from "../../assets/images/home/plus500.svg";
import IconQuantumrock from "../../assets/images/home/quantumrock.svg";
import IconSix from "../../assets/images/home/six.svg";
import IconSubtract from "../../assets/images/home/subtract.svg";
import IconXm from "../../assets/images/home/xm.svg";

export const CLIENT_LIST = [
  {
    id: 0,
    label: "Six",
    image: IconSix,
  },
  {
    id: 1,
    label: "GlobalX",
    image: IconGlobalx,
  },
  {
    id: 2,
    label: "abrdn",
    image: IconAbrdn,
  },
  {
    id: 3,
    label: "Plus500",
    image: IconPlus500,
  },
  {
    id: 4,
    label: "IG",
    image: IconSubtract,
  },
  {
    id: 5,
    label: "Malanion Capital",
    image: IconMelanion,
  },
  {
    id: 6,
    label: "iClima",
    image: IconIClima,
  },
  {
    id: 7,
    label: "Direxion",
    image: IconDirexion,
  },
  {
    id: 8,
    label: "XM",
    image: IconXm,
  },
  {
    id: 9,
    label: "PepperStone",
    image: IconPepperstone,
  },
  {
    id: 10,
    label: "AvaTrade",
    image: IconAvatrade,
  },
  {
    id: 11,
    label: "EQM",
    image: IconEqm,
  },
  {
    id: 12,
    label: "LGC",
    image: IconLgc,
  },
  {
    id: 13,
    label: "impak",
    image: IconImpak,
  },
  {
    id: 14,
    label: "QuantrumRock",
    image: IconQuantumrock,
  },
  {
    id: 15,
    label: "LMAX",
    image: IconLmax,
  },
  {
    id: 16,
    label: "Gain Capital",
    image: IconGain,
  },
];

export const CLIENT_LIST_DESKTOP = [
  [
    [
      {
        id: 0,
        label: "Six",
        image: IconSix,
      },
      {
        id: 1,
        label: "GlobalX",
        image: IconGlobalx,
      },
      {
        id: 2,
        label: "iClima",
        image: IconIClima,
      },
      {
        id: 3,
        label: "Direxion",
        image: IconDirexion,
      },
      {
        id: 4,
        label: "XM",
        image: IconXm,
      },
    ],
    [
      {
        id: 5,
        label: "PepperStone",
        image: IconPepperstone,
      },
      {
        id: 6,
        label: "AvaTrade",
        image: IconAvatrade,
      },
      {
        id: 7,
        label: "abrdn",
        image: IconAbrdn,
      },
      {
        id: 8,
        label: "Plus500",
        image: IconPlus500,
      },
      {
        id: 9,
        label: "IG",
        image: IconSubtract,
      },
    ],
  ],
  [
    [
      {
        id: 10,
        label: "Malanion Capital",
        image: IconMelanion,
      },
      {
        id: 11,
        label: "EQM",
        image: IconEqm,
      },
      {
        id: 12,
        label: "LGC",
        image: IconLgc,
      },
      {
        id: 13,
        label: "impak",
        image: IconImpak,
      },
    ],
    [
      {
        id: 14,
        label: "QuantrumRock",
        image: IconQuantumrock,
      },
      {
        id: 15,
        label: "LMAX",
        image: IconLmax,
      },
      {
        id: 16,
        label: "Gain Capital",
        image: IconGain,
      },
    ],
  ],
];
